import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { BatchCreateUserGroups } from '@cast/types-organization-management';

import { ENTERPRISE_ORGANIZATION_CHILD_USER_GROUPS_QUERY_KEY } from 'hooks/queries/enterprise';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useBatchCreateUserGroupsMutation = () => {
  const queryClient = useQueryClient();
  const { enterpriseOrgId } = useOrganizations();

  return useMutation({
    mutationFn: (userGroupCreations: BatchCreateUserGroups[]) => {
      return apiClient.enterprises.batchCreateUserGroups(
        {
          enterpriseId: enterpriseOrgId!,
          batchCreateEnterpriseGroupsRequest: {
            enterpriseId: enterpriseOrgId!,
            requests: userGroupCreations,
          },
        },
        {
          headers: overrideOrganizationHeader(enterpriseOrgId),
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ENTERPRISE_ORGANIZATION_CHILD_USER_GROUPS_QUERY_KEY],
      });
    },
    onError: (error) => notify.error(parseApiError(error)),
  });
};
